<template>
  <v-flex xs12 class="header" :style="headerStyle">
    <email-form />
    <v-layout v-if="$vuetify.breakpoint.mdAndUp && !showArticleOnly">
      <div style="float:left;width:200px;">
        <div class="logo" style="padding-left: 25px;">
          <a style="" @click="goHomeAndClearSearch"><img style="width: 130px;" src="./../../public/img/costa-sol-rent-logo.png" alt="Costasolrent.com"></a>
        </div>
      </div>
      <div style="float:left;width:calc(100% - 400px);padding-top:25px;padding-left: 20px; pading-right: 40px;">
        <div class="slogan">
          {{ $t('siteSlogan') }}
        </div>
      </div>
      <div style="float:right;width:200px;text-align:right;">
        <img
          v-if="!weather && weather && weather.current && weather.current.weather_code"
          style="width: 35px; margin-bottom: 4px;"
          :src="'/img/weather/' + (
            weather.current.is_day === 'yes' ? 'sunny' : 'moon'
            ) + '.png'"
        />
        <div
          v-if="!weather && weather && weather.current && weather.current.temperature"
          class="temp_value"
        >
          {{ weather.current.temperature > 0 ? ('+' + weather.current.temperature) : ('-' + weather.current.temperature) }} °C
        </div>
        <flags className="flags" />
        </div>
    </v-layout>

    <template v-else>
      <v-toolbar :fixed="windowWidth < windowHeight" dark class="mobile-menu mobile-header-buttons">

        <template v-if="showArticleOnly">
          <v-btn icon depressed flat @click="goBackOrClose">
            <v-icon large>chevron_left</v-icon>
          </v-btn>
          <div
            style="cursor: pointer; "
            @click="goBackOrClose"
          >
            <b>
              {{ capitalize($i18n.t('back')) }}
            </b>
          </div>
        </template>
        <div
          v-else
          style="cursor:pointer; "
          @click="showLeftMenu = true"
        >
          <b>
            {{ $i18n.t('contact_us') }}
          </b>
        </div>

        <v-spacer></v-spacer>
        <flags className="mobile-flags" :use-menu="true"/>
        <i
          style="position: relative; left: -4px;"
          class="fa fa-angle-down"
        ></i>
        <!-- div class="mobile-flags">
          <a @click="changeLang('et')"><img src="/img/est.png" alt="Eesti"></a>
          <a @click="changeLang('en')"><img src="/img/eng.png" alt="English"></a>
          <a @click="changeLang('fi')"><img src="/img/fin.png" alt="Finnish"></a>
          <a @click="changeLang('ru')"><img src="/img/rus.png" alt="Russian"></a>
          <a @click="changeLang('es')"><img src="/img/esp.png" alt="Spanish"></a>
        </div -->
        <div class="justify-end"
          v-if="!showArticleOnly && favorites.length > 0"
        >
          <i
            :class="'favorites-btn-mobile mobile-header-btn ' + (searchFilters.favorites === 1 ? 'fa fa-heart' : 'far fa-heart')"
            @click="goToFavorites()"
          ></i>
        </div>

        <template
          v-if="!showArticleOnly"
        >
          <div
            v-if="!showArticleOnly"
            class="justify-end"
            @click="mobileShare()"
          >
            <i class="fa fa-share mobile-header-btn" />
          </div>
          <div
            class="justify-end" @click="openFacebook()"
          >
            <span class="mdi mdi-facebook-box mobile-header-btn"></span>
          </div>
          <div
            class="justify-end" @click="openInstagram()"
          >
            <span class="mdi mdi-instagram mobile-header-btn"></span>
          </div>
        </template>
        <v-toolbar-side-icon
          v-if="!showArticleOnly"
          @click="showRightMenu = !showRightMenu"
        />
      </v-toolbar>
      <v-layout wrap :style="windowWidth >= windowHeight ? 'margin-top: -48px;' : ''">
        <v-flex xs4>
        </v-flex>
        <v-flex xs4 class="mobile-logo"
          style="color: #e3bb22; font-weight: 700;"
        >
          <a
            style="cursor:pointer;"
            @click="goHomeAndClearSearch"
          >
            <img src="./../../public/img/costa-sol-rent-logo.png"
              alt="Costasolrent.com"
              width="85px"
              >
          </a>
        </v-flex>
        <v-flex xs4 style="padding-top: 48px;">

          <div
            v-if="weather && weather.current && weather.current.temperature"
            class="mobile-temp-value"
          >
              <div class="mobile-temp-text">
                {{ weather.current.temperature > 0 ? ('+' + weather.current.temperature)
                  : ('-' + weather.current.temperature) }} °C
              </div>
          </div>
        </v-flex>
      </v-layout>
    </template>
  </v-flex>
</template>

<script>
import Flags from './Flags'
import EmailForm from './_EmailForm'
import sharedMethods from './../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'PageHeader',

  components: {
    EmailForm,
    Flags
  },

  computed: {
    ...mapFields(Object.keys(state)),

    headerStyle () {
      return {
        height: this.$vuetify.breakpoint.mdAndUp ? '110px' : '115px'
      }
    }
  },

  methods: {
    ...sharedMethods,

    goBackOrClose () {
      window.close()
      // window.history.back()
    },

    openFacebook () {
      window.open('https://www.facebook.com/costasolrent/', '_blank')
    },

    openInstagram () {
      window.open('https://www.instagram.com/costasolrent.fi/', '_blank')
    }
  }
}
</script>

<style>
.mobile-menu {
  color: #333333 !important;
}
.mobile-menu .theme--dark.v-btn {
  color: #333333;
}
.mobile-menu .v-toolbar__content {
  height: 48px !important;
}
.mobile-weather-img {
  width: 30px;
}
.mobile-temp-value {
  font-size: 14px;
  color: white;
  text-align: right;
  font-weight: bold;
  padding-right: 5px;
}
.mobile-temp-img, .mobile-temp-text {
  float: right;
}
.mobile-temp-text {
  padding-top: 10px;
  padding-right: 10px;
}
.mobile-temp-img {
  padding-top: 5px;
}
.theme--dark.v-toolbar {
  background-color: inherit !important;
}
.mobile-menu .theme--dark.v-toolbar {
  background-color: inherit !important;
}
.v-toolbar {
  background: url(/img/menu_bg.jpg) repeat 0 top;
}
.mobile-logo {
  padding-top: 10px;
  text-align: center;
}
.mobile-logo a img {
  max-height: 95px;
}
.mobile-flags {
  text-align: center;
}
.mobile-flags a {
  padding: 0 3px;
}
.mobile-flags a img {
  width: 25px;
  padding-top: 5px;
}
.favorites-btn-mobile {
  color: red;
}
.mobile-header-btn {
  padding: 5px 9px 0 9px;
  font-size: 21px;
}
.mobile-header-buttons .mdi {
  font-size: 25px;
}
/*
.temp_value {
  position: relative;
  top: -15px;
  font-size: 21px;
  color: white;
  font-weight: bold;
  margin: 0;
  padding: 0;
}
*/
</style>
